import CoveredInClassRAv2 from './component';

import _routes from './routes';

export const routes = _routes;

export default CoveredInClassRAv2;



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClassRAv2/index.js